import $ from "jquery";

$(".accordion").each(function () {
    $(this).find('[data-bs-toggle="collapse"]').on('click', function (e) {
        setTimeout(function () {
            if ($(e.currentTarget).attr('aria-expanded') !== 'true') {
                history.replaceState({}, "", ' ')
            } else {
                history.replaceState({}, "", $(this).data('bs-target'))
            }
        }.bind(this), 100)
    })

    if (window.location.hash) {
        setTimeout(function () {
            let $accordionCollapse = $(window.location.hash + ".accordion-collapse")

            if ($accordionCollapse.length) {
                bootstrap.Collapse.getOrCreateInstance(
                    $accordionCollapse[0]
                ).show()
            }
        }, 0);
    }
})


$('.accordion-button').on('click', function () {
    var accordionItem = $('.accordion-item');

    accordionItem.removeClass('active');
    accordionItem.removeClass('completed');

    var currentItem = $(this).closest('.accordion-item');

    if ($(this).attr('aria-expanded') === 'true') {
        currentItem.addClass('active');
        currentItem.prevAll('.accordion-item').addClass('completed');
    }
});